export default __webpack_public_path__ + "components/weather-icon/static/dayclear@2-774596e57af02c133b43f6f60773613e.png";